import styled from 'styled-components';
import {
  buildColorWarningKey,
  ComponentOrReferenceFormattingRule,
  FormattingColorPicker,
  type FormattingContextState,
} from '@ardoq/perspectives';
import { space } from '@ardoq/design-tokens';
import { RowHeader } from '../../../atoms';
import { BottomRowWrapper } from './atoms';
import { ColorPickerWrapper } from '@ardoq/perspectives';

const FormattingRuleRowContainer = styled(BottomRowWrapper)`
  gap: ${space.small};
`;

type FormattingRuleSingleRowColorAndValueEditorsProperties = {
  rule: ComponentOrReferenceFormattingRule;
  formattingContext: FormattingContextState;
  colorPaletteAlignment?: 'left' | 'right';
};
const FormattingRuleColorPickerOnly = ({
  rule,
  formattingContext,
  colorPaletteAlignment = 'right',
}: FormattingRuleSingleRowColorAndValueEditorsProperties) => {
  const { __id: ruleId, color } = rule;
  const { updateRule, ruleInfo } = formattingContext;
  const { colorWarnings = {} } = ruleInfo[rule.__id] || {};
  const colorWarning = colorWarnings[buildColorWarningKey(rule.color)];
  return (
    <>
      <RowHeader>Value</RowHeader>
      <FormattingRuleRowContainer>
        <ColorPickerWrapper $hasWarning={Boolean(colorWarning)}>
          <FormattingColorPicker
            hasWarning={Boolean(colorWarning)}
            dataTestId="formatting-rule-color-picker"
            value={color}
            onValueChange={color => updateRule(ruleId, { color })}
            isNewConditionalFormatting={true}
            colorPaletteAlignment={colorPaletteAlignment}
          />
        </ColorPickerWrapper>
      </FormattingRuleRowContainer>
    </>
  );
};
export { FormattingRuleColorPickerOnly };
